import {
	SHOW_WARNING_THRESHOLD,
	RESTING,
	ABOUT_TO_REACH_MAX,
	MAX_REACHED,
} from '../../../../../../../common/ui/constants.tsx';

export const getLimitState = (maxGoals: number, remainingGoals: number): string => {
	if (remainingGoals < 1) {
		return MAX_REACHED;
	}

	if (remainingGoals <= SHOW_WARNING_THRESHOLD) {
		return ABOUT_TO_REACH_MAX;
	}

	return RESTING;
};
